/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import CustomButtons from './CustomButtons';
import CustomDropdownPrivacy from './CustomDropdownPrivacy';

const CustomOptions = ({
  editorState,
  isEdit,
  onButtonAdd,
  onButtonCancel,
  onButtonUpdate,
  onPrivacyChange,
  privacyValue,
  showInternalPrivacy,
  submitIsDisable,
}) => (
  <div className="rdw-custom-options">
    <CustomDropdownPrivacy
      onChange={onPrivacyChange}
      privacyValue={privacyValue}
      showInternalPrivacy={showInternalPrivacy}
    />
    <CustomButtons
      isEdit={isEdit}
      onButtonAdd={onButtonAdd}
      onButtonCancel={onButtonCancel}
      onButtonUpdate={onButtonUpdate}
      submitIsDisable={submitIsDisable}
    />
  </div>
  );

CustomOptions.propTypes = {
  editorState: PropTypes.oneOfType([PropTypes.object]),
  isEdit: PropTypes.bool,
  onButtonAdd: PropTypes.func.isRequired,
  onButtonCancel: PropTypes.func.isRequired,
  onButtonUpdate: PropTypes.func.isRequired,
  onPrivacyChange: PropTypes.func.isRequired,
  privacyValue: PropTypes.string,
  showInternalPrivacy: PropTypes.bool,
  submitIsDisable: PropTypes.bool,
};

export default CustomOptions;



// WEBPACK FOOTER //
// ./src/components/BookingNote/NoteEditor/CustomOptions.jsx